import React from 'react'
import Loader from './loader'
import { useAuth } from 'context/auth'

function CDButton({ disabled, processing, label, type, className, ...rest }) {
  const {currentUser} = useAuth()
  const pri_btn_bg_color = currentUser?.account?.branding?.buttonBackgroundColor
  const btn_text_color = currentUser?.account?.branding?.buttonTextColor

  return (
    <button
      type={type || 'submit'}
      disabled={disabled || processing}
      className={`btn ${disabled || processing ? 'disable' : ''} ${className}`}
      style={{backgroundColor: pri_btn_bg_color, color: btn_text_color}}
      {...rest}
    >
      {processing ? <Loader /> : label}
    </button>
  )
}

export default CDButton
